import React, { useCallback } from "react";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const MemberCountWidget = ({ customizeMode, onRemove, dateRange }) => {
  const fetcher = useCallback((token) => ReportingService.getWidgetMemberCount(token, dateRange), [dateRange]);
  const { data, loading, error, retry } = useWidgetData(fetcher);

  return (
    <WidgetWrapper
      title="Active Members"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      <div className="stat-widget">
        <div className="stat-widget__value">{data?.active ?? 0}</div>
        <div className="stat-widget__sub">Active memberships</div>
        <div className="stat-widget__mini-tiles">
          <div className="stat-widget__mini-tile">
            <div className="tile-val">{data?.families ?? 0}</div>
            <div className="tile-lbl">Families</div>
          </div>
          <div className="stat-widget__mini-tile">
            <div className="tile-val tile-val--green">+{data?.newThisMonth ?? 0}</div>
            <div className="tile-lbl">New this period</div>
          </div>
        </div>
      </div>
    </WidgetWrapper>
  );
};

export default MemberCountWidget;
